import type { Key } from "./en";

// Nederlandse teksten. Dezelfde sleutels als en.ts.
const nl: Record<Key, string> = {
  "app.name": "DamaTrainer",
  "nav.train": "Trainen",
  "nav.dashboard": "Overzicht",
  "nav.modules": "Modules",
  "nav.leaderboard": "Ranglijst",
  "nav.favorites": "Favorieten",
  "nav.history": "Geschiedenis",
  "nav.admin": "Beheer",
  "nav.profile": "Profiel",
  "nav.login": "Inloggen",
  "nav.logout": "Uitloggen",
  "nav.signup": "Aanmelden",
  "nav.theme": "Licht / donker",

  "landing.title": "Vind de combinatie.",
  "landing.lead": "Damcombinaties precies op jouw niveau. Je rating beweegt mee met elke opgave, en de site zegt het je - vriendelijk - als je hem hebt.",
  "landing.start": "Begin met trainen",
  "landing.try": "Probeer deze: wit speelt en wint.",
  "landing.taster_done": "Maak een account aan om je rating te bewaren.",

  "auth.email": "E-mail",
  "auth.password": "Wachtwoord",
  "auth.name": "Weergavenaam",
  "auth.login": "Inloggen",
  "auth.signup": "Account aanmaken",
  "auth.forgot": "Wachtwoord vergeten?",
  "auth.no_account": "Nog geen account?",
  "auth.have_account": "Heb je al een account?",
  "auth.send_reset": "Stuur een herstellink",
  "auth.reset_sent": "Als dat adres een account heeft, is er een link onderweg.",
  "auth.new_password": "Nieuw wachtwoord",
  "auth.set_password": "Wachtwoord instellen",
  "auth.reset_done": "Wachtwoord gewijzigd. Je kunt nu inloggen.",
  "auth.verified": "Bedankt, je e-mailadres is bevestigd.",
  "auth.verify_failed": "Deze link is niet (meer) geldig.",
  "auth.verify_hint": "Kijk in je mail om je adres te bevestigen.",

  "err.bad_credentials": "E-mail of wachtwoord klopt niet.",
  "err.too_many_attempts": "Te veel pogingen. Wacht even een minuut.",
  "err.email_taken": "Er is al een account met dit e-mailadres.",
  "err.name_taken": "Die weergavenaam is al bezet.",
  "err.invalid_code": "Die code is niet geldig.",
  "err.generic": "Er ging iets mis. Probeer het nog eens.",
  "err.invalid_email": "Dat is geen geldig e-mailadres.",
  "err.invalid_input": "Controleer de velden: er klopt iets niet.",

  "seed.title": "Hoe goed ken je combinaties?",
  "seed.lead": "Kies er een; de eerste tien opgaven bepalen je niveau.",
  "seed.new": "Nieuw met combinaties",
  "seed.club": "Clubspeler",
  "seed.strong": "Sterke speler",

  "train.white_to_play": "Wit aan zet",
  "train.placement": "Plaatsing {i}/{n}",
  "train.second_chance": "Tweede kans",
  "train.review": "Herhaling",
  "train.daily": "Opgave van de dag",
  "train.taster": "Proefopgave {i}/{n}",
  "train.black_also": "Zwart kan ook {move} spelen",
  "train.intro": "Zwart speelt {move}",
  "train.lines": "Variant {i} van {n}",
  "train.easier": "Makkelijker",
  "train.normal": "Normaal",
  "train.harder": "Moeilijker",
  "train.give_up": "Toon oplossing",
  "train.report": "Meld een probleem",
  "train.favorite": "Favoriet",
  "train.unfavorite": "Geen favoriet meer",
  "train.exhausted": "Je hebt hier alle opgaven gedaan.",
  "train.exhausted_hint": "Herhaal je fouten, of open een andere module.",
  "train.mistakes_empty": "Er staan geen fouten klaar. Netjes!",
  "train.favorites_empty": "Nog geen favorieten. Geef een opgave een ster.",
  "train.rating": "Rating {r}",
  "train.loading": "Bord klaarzetten…",
  "train.sound": "Geluid",
  "train.input": "Zetinvoer",
  "train.auto_next": "Na het oplossen automatisch naar de volgende opgave",
  "train.all_labels": "Alle combinaties ({n})",
  "train.label_done": "Je hebt alle opgaven met het label \u201c{label}\u201d gedaan.",
  "train.label": "Welke combinaties",
  "train.all": "Alle combinaties",
  "train.label_search": "Zoek een label",
  "train.label_none": "Geen label gevonden.",

  "move.must_capture": "Slaan is verplicht.",
  "move.most_pieces": "Je moet de meeste stukken slaan: hier {n}.",
  "move.one_jump": "Eén sprong tegelijk: klik eerst het veld waar je schijf landt.",
  "move.piece_first": "Klik eerst de schijf die je wilt spelen.",
  "move.cannot_move": "Deze schijf kan niet zetten.",
  "move.finish_first": "Maak deze slag af, of druk Esc om opnieuw te beginnen.",
  "move.choose": "Twee manieren van slaan: klik een schijf die je wilt slaan.",
  "move.assist": "Hulp",
  "move.beginner": "Beginner - klik elke sprong",
  "move.advanced": "Gevorderd - zo min mogelijk klikken",
  "move.drag": "Schijven slepen",
  "move.targets": "Mogelijke zetten tonen",
  "train.mistakes": "Fouten herhalen",

  "result.solved_in": "Opgelost in {t}",
  "result.not_solved": "Niet opgelost",
  "result.faster": "Sneller dan {p}% van de spelers",
  "result.replay": "Naspelen",
  "result.next": "Volgende",
  "result.retry": "Opnieuw",
  "result.show": "Toon oplossing",
  "result.unrated": "Telt niet mee",
  "result.exercise_rating": "Opgave {r}",
  "result.placement_done": "Jouw rating",

  "fb.not_this_time": "Deze keer niet. De oplossing begint met {move}.",
  "fb.back_tomorrow": "Morgen komt hij terug.",
  "fb.above_level": "Die was boven je niveau. Goed gevonden!",
  "fb.new_best": "Nieuw record: {rating}",
  "fb.streak": "{n} op rij ✦",
  "fb.first_theme": "Je eerste {theme}!",
  "fb.deep": "{n} zetten diep - mooi berekend.",
  "fb.clean_quick": "Strak en snel.",
  "fb.solved_1": "Goed gespeeld.",
  "fb.solved_2": "Dat is hem.",
  "fb.solved_3": "Keurig.",
  "fb.solved_4": "Gevonden.",
  "fb.solved_5": "Precies raak.",

  "ms.solved": "{n} opgelost",
  "ms.rating": "{rating} bereikt",
  "ms.module": "{title} afgerond",
  "ms.day_streak": "{n} dagen op rij",

  "level.beginner": "Je begint net met combinaties - het leukste komt nog.",
  "level.improving": "Je ziet de basisslagen. Tijd om dieper te gaan.",
  "level.club": "Je lost combinaties op als een clubspeler.",
  "level.strong_club": "Je lost combinaties op als een sterke clubspeler.",
  "level.expert": "Je rekent als een expert.",
  "level.master": "Meesterlijk overzicht. Indrukwekkend.",

  "sol.title": "Oplossing",
  "sol.variations": "Varianten",
  "sol.your_moves": "Jouw zetten",
  "sol.main": "Hoofdvariant",

  "report.title": "Meld een probleem",
  "report.other_solution": "Een andere zet wint ook",
  "report.wrong_solution": "De oplossing klopt niet",
  "report.wrong_position": "De stelling klopt niet",
  "report.other": "Iets anders",
  "report.text": "Wat viel je op?",
  "report.send": "Versturen",
  "report.thanks": "Bedankt - we kijken ernaar.",

  "dash.greeting_morning": "Goedemorgen, {name}",
  "dash.greeting_afternoon": "Goedemiddag, {name}",
  "dash.greeting_evening": "Goedenavond, {name}",
  "dash.rating": "Rating",
  "dash.last7": "laatste 7 dagen",
  "dash.solved": "Opgelost",
  "dash.this_week": "+{n} deze week",
  "dash.accuracy": "Score 30 d",
  "dash.streak": "Reeks",
  "dash.day": "{n} dag",
  "dash.days": "{n} dagen",
  "dash.rating_chart": "Rating",
  "dash.activity": "Activiteit",
  "dash.by_theme": "Per thema",
  "dash.train_theme": "Trainen",
  "dash.weekly": "Opgelost en gemist per week",
  "dash.by_band": "Per opgaverating",
  "dash.to_review": "Te herhalen: {n}",
  "dash.favorites": "Favorieten: {n}",
  "dash.in_progress": "Modules onderweg",
  "dash.start": "Start",
  "dash.open": "Open",
  "dash.placing": "Rond de plaatsing af om je rating te zien.",
  "dash.empty": "Los een paar opgaven op en je voortgang verschijnt hier.",
  "dash.accuracy_col": "Score",
  "dash.time_col": "Gem. tijd",
  "dash.solved_label": "opgelost",
  "dash.failed_label": "gemist",

  "mod.title": "Modules",
  "mod.solved": "{s} / {n} opgelost",
  "mod.avg": "gem. {r}",
  "mod.redeem": "Code invoeren",
  "mod.redeem_ok": "Ontgrendeld!",
  "mod.locked": "Op slot",
  "mod.start": "Start",
  "mod.continue": "Verder",
  "mod.unrated": "telt niet mee",
  "mod.course": "cursus",

  "fav.title": "Favorieten",
  "fav.practice": "Favorieten oefenen",
  "fav.sort_date": "Nieuwste",
  "fav.sort_rating": "Rating",
  "fav.all_modules": "Alle modules",
  "fav.empty": "Nog geen favorieten.",

  "hist.title": "Geschiedenis",
  "hist.all": "Alle resultaten",
  "hist.solved_first": "In één keer",
  "hist.solved_later": "Later opgelost",
  "hist.failed": "Gemist",
  "hist.mastered": "Beheerst",
  "hist.period_all": "Altijd",
  "hist.period_7": "7 dagen",
  "hist.period_30": "30 dagen",
  "hist.period_365": "1 jaar",
  "hist.empty": "Hier staat nog niets.",
  "hist.prev": "Vorige",
  "hist.next": "Volgende",

  "lb.title": "Ranglijst",
  "lb.rating": "Rating",
  "lb.week": "Deze week",
  "lb.module": "Per module",
  "lb.all": "Iedereen",
  "lb.club": "Mijn club",
  "lb.country": "Mijn land",
  "lb.you": "Jij: #{rank} van {total}",
  "lb.empty": "Nog niemand.",
  "lb.need_club": "Vul eerst je club in bij je profiel.",
  "lb.need_country": "Vul eerst je land in bij je profiel.",
  "lb.rating_rule": "Vanaf 50 opgaven met rating, een stabiele rating en activiteit in de laatste 30 dagen.",

  "prof.title": "Profiel en instellingen",
  "prof.club": "Club",
  "prof.country": "Land (twee letters)",
  "prof.sound": "Geluid",
  "prof.coords": "Veldnummers op het bord",
  "prof.board": "Bordkleuren",
  "prof.board_wood": "Hout",
  "prof.board_green": "Groen",
  "prof.board_blue": "Blauw",
  "prof.theme": "Weergave",
  "prof.theme_system": "Volg systeem",
  "prof.theme_light": "Licht",
  "prof.theme_dark": "Donker",
  "prof.language": "Taal",
  "prof.hide": "Verberg mij in de ranglijsten",
  "prof.save": "Opslaan",
  "prof.saved": "Opgeslagen.",
  "prof.password": "Wachtwoord wijzigen",
  "prof.current": "Huidig wachtwoord",
  "prof.data": "Jouw gegevens",
  "prof.download": "Download mijn gegevens",
  "prof.delete": "Account verwijderen",
  "prof.delete_confirm": "Je account verwijderen? Je pogingen blijven, geanonimiseerd, voor de statistiek.",

  "common.save": "Opslaan",
  "common.cancel": "Annuleren",
  "common.close": "Sluiten",
  "common.loading": "Laden…",
  "common.seconds": "{n} s",
};

export default nl;
